jQuery(function( $ ) {
    "use strict"

    vector.toggleBlock();
    vector.mixedMediaSliderBlock();
    vector.logoSliderBlock();
    vector.expandCollapseBlock();

});



// WEBPACK FOOTER //
// ./resources/assets/scripts/interior.js